import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CartObject } from './cart-object';
import { Cart, CartClient, User } from './WOWApi.Service';
import { CustomServiceService } from './custom-service.service';
import { CommonServices } from '../Common/CommonServices';

@Injectable({
  providedIn: 'root'
})
export class CommonService implements OnDestroy {
  private tempMobileView  = new BehaviorSubject<boolean>(false);
  isMobileView = this.tempMobileView.asObservable();

  private tempFooterCollapse = new BehaviorSubject<boolean>(true);
  isFooterCollapsible = this.tempFooterCollapse.asObservable();

  private cartDetailsTemp = new BehaviorSubject<CartObject[]>([]);
  cartDetails = this.cartDetailsTemp.asObservable();

  private cartExpireRemainingTimeTemp = new BehaviorSubject<string>('');
  cartExpireRemainingTime = this.cartExpireRemainingTimeTemp.asObservable();

  private userCartTemp = new BehaviorSubject<any>({cartDetails: []});
  userCart = this.userCartTemp.asObservable();

  private billingAddressTemp = new BehaviorSubject<any>(null);
  billingAddress = this.billingAddressTemp.asObservable();

  private shippingAddressTemp = new BehaviorSubject<any>(null);
  shippingAddress = this.shippingAddressTemp.asObservable();

  private communicationMethodsTemp = new BehaviorSubject<any>(null);
  communicationMethods = this.communicationMethodsTemp.asObservable();

  private isUserLoggedInTemp = new BehaviorSubject<boolean>(false);
  isUserLoggedIn = this.isUserLoggedInTemp.asObservable();

  private isShowSpinnerTemp = new BehaviorSubject<boolean>(false);
  isShowSpinner = this.isShowSpinnerTemp.asObservable();

  private isPageReloadTemp = new BehaviorSubject<boolean>(false);
  isPageReload = this.isPageReloadTemp.asObservable();

  private isLoggedInUserHostOrAdminTemp = new BehaviorSubject<boolean>(false);
  isLoggedInUserHostOrAdmin = this.isLoggedInUserHostOrAdminTemp.asObservable();

  private currentWebinarSurfedTemp = new BehaviorSubject<number>(0);
  currentWebinarSurfed = this.currentWebinarSurfedTemp.asObservable();

  subscription: Subscription;
  cartExpiryIntervalId: any;
  private CART_EXPIRY_TIME: number = 300;
  constructor(
    private customServices: CustomServiceService,
    private cartClient: CartClient,
    private commonServices: CommonServices
  ) { }

  setMobileView(value: boolean) {
    this.tempMobileView.next(value);
  }

  setFooterCommapsible(value: boolean) {
    this.tempFooterCollapse.next(value);
  }

  setCartDetails(details: CartObject[]) {
    this.cartDetailsTemp.next(details);
  }

  setShippingAddress(shippingAddress: any) {
    this.shippingAddressTemp.next(shippingAddress);
  }

  setBillingAddress(billingAddress: any) {
    this.billingAddressTemp.next(billingAddress);
  }

  setCommunicationMethods(comMethods: any) {
    this.communicationMethodsTemp.next(comMethods);
  }

  setUserLoggedIn(state: boolean) {
    this.isUserLoggedInTemp.next(state);
  }

  setSpinner(isShow: boolean) {
    this.isShowSpinnerTemp.next(isShow);
  }

  setUserHostOrAdmin(isShow: boolean) {
    this.isLoggedInUserHostOrAdminTemp.next(isShow);
  }

  updateCartExpiryRemainingTime(remainingTime: string) {
    this.cartExpireRemainingTimeTemp.next(remainingTime);
  }

  setIsPageReload(value: boolean) {
    this.isPageReloadTemp.next(value);
  }

  setcurrentWebinarSurfed(value: number) {
    this.currentWebinarSurfedTemp.next(value);
  }

  setUserCart(cart: Cart | any) {
    this.userCartTemp.next(cart);
    clearInterval(this.cartExpiryIntervalId);
    if (cart.cartDetails.length > 0) {
      this.processCartItemsForCartExpiryRemainingTime(cart);
    } else {
      this.updateCartExpiryRemainingTime('0');
    }
  }

  splitArrayIntoChunks(arr: any[], chunkSize: number): any[][] {
    const result = [];
    if(arr != null && arr.length > 0) {
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
  }
    return result;
  }

  processCartItemsForCartExpiryRemainingTime(cart: Cart): void {
    // Clear any existing interval to avoid overlaps
    if (this.cartExpiryIntervalId) {
      clearInterval(this.cartExpiryIntervalId);
    }
  
    if (!cart?.cartDetails?.length) return;
  
    const sortedItems = [...cart.cartDetails].sort((a, b) =>
      new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime()
    );
    const oldestItem = sortedItems[0];
    const itemCreatedTime = new Date(oldestItem.createdDate).getTime();
  
    this.cartExpiryIntervalId = setInterval(() => {
      const now = this.getUtcNow(new Date()).getTime();
      const elapsedSeconds = Math.floor((now - itemCreatedTime) / 1000);
      const remaining = this.CART_EXPIRY_TIME - elapsedSeconds;
  
      if (remaining <= 0) {
        this.emptyCartAfterExpiryTime();
        this.updateCartExpiryRemainingTime('0:00');
        clearInterval(this.cartExpiryIntervalId);
      } else {
        const minutes = Math.floor(remaining / 60);
        const seconds = remaining % 60;
        const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        this.updateCartExpiryRemainingTime(formattedTime);
      }
    }, 1000);
  }

  emptyCartAfterExpiryTime() {
    let cart: Cart;
    this.subscription = this.userCart.subscribe(res => cart = res);
    const loggedInUser: User = this.customServices.GetLoggedInUser();
    if (loggedInUser !== undefined && loggedInUser.id !== undefined && loggedInUser.id !== null && loggedInUser.id !== 0) {
      this.cartClient.deleteAllCartItemsByUserId(loggedInUser.id).subscribe(res => {
        if (res === true) {
          this.commonServices.showMessage('Success', `Cart is empty now, items removed due to expired hold time`, 5);
          const emptyCart: any = {cartDetails: []};
          clearInterval(this.cartExpiryIntervalId);
          this.setUserCart(emptyCart);
        }
      })
    } else {
      this.commonServices.showMessage('Error', `Invalid User id.`);
    }
  }

  getUtcNow(date: Date) {
    var utc = new Date( date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds() );
    return utc;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
